<h2 mat-dialog-title>Open with...</h2>

@for (row of resolversGrid; track row) {
  <mat-dialog-content fxLayout="row" fxLayoutAlign="start start">
    @for (resolver of row; track resolver) {
      <button mat-button fxFlex="33" fxLayout="column" fxLayoutAlign="center start"
        (click)="onIntentClicked(resolver)">
        {{resolver.handler.Name}}
      </button>
    }
  </mat-dialog-content>
}
